module.exports = __webpack_public_path__ + "img/completion9.fefd02d0.svg";